import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import moment from 'moment';

const FirmwareField: React.FC = () => {
	const { latestSoftwareUpdateData } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const inputValue = latestSoftwareUpdateData?.lastFimrwareAssignedDate
		? `${moment(latestSoftwareUpdateData.lastFimrwareAssignedDate).format('MM/DD/YYYY h:mm:ss A')} ${
				latestSoftwareUpdateData.lastFirmwareVersionName
		  }`
		: undefined;

	return <FullInfoField label="firmwareLabel" value={inputValue} />;
};

export default FirmwareField;
